// extracted by mini-css-extract-plugin
export var restrictedWidthButton = "_oq-0";